import { render, staticRenderFns } from "./BackAlbum.vue?vue&type=template&id=447d9373&scoped=true"
import script from "./BackAlbum.vue?vue&type=script&lang=js"
export * from "./BackAlbum.vue?vue&type=script&lang=js"
import style0 from "./BackAlbum.vue?vue&type=style&index=0&id=447d9373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d9373",
  null
  
)

export default component.exports